import React from 'react';
import { AwardIcon, CheckIcon, LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { checkoutUrl, included, price, priceBefore, productName, totalBonuses, totalVolumes } from '../data/offer';
export function PricingSection() {
  return <section id="pricing" className="scroll-mt-4 bg-cream py-16 sm:py-24" aria-labelledby="pricing-title" data-id="element-159" data-mp="1j9gwqm2xz77s">
      <div className="mx-auto max-w-3xl px-4" data-id="element-160" data-mp="1nbbwvn94zejz">
        <h2 id="pricing-title" className="text-center text-3xl font-extrabold text-ink sm:text-4xl" data-id="element-161" data-mp="1naahj6l385wg">
          Choose your option
        </h2>

        <article className="mt-10 overflow-hidden rounded-2xl border border-line bg-panel shadow-lift" data-id="element-162" data-mp="1x86vs79bngys">
          <div className="energy-bar h-2 w-full" aria-hidden="true" data-id="element-163" data-mp="2282z04a734da" />
          <div className="p-6 sm:p-10" data-id="element-164" data-mp="2up3k6xz1vxf">
            <span className="inline-flex items-center gap-2 rounded-md bg-forest px-3 py-1.5 text-[11px] font-extrabold uppercase tracking-[.16em] text-sageGlow" data-id="element-165" data-mp="2vqsnfbtoiy5">
              <AwardIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-166" data-mp="1mgohbip5jno1" /> Main offer
            </span>

            <div className="mt-5 flex flex-col gap-6 border-b border-line pb-7 sm:flex-row sm:items-end sm:justify-between" data-id="element-167" data-mp="1hpy6vr1vcumh">
              <div data-id="element-168" data-mp="1cq3l21wyav8a">
                <h3 className="font-display text-2xl font-extrabold uppercase leading-tight text-ink" data-id="element-169" data-mp="1crmwnf7nwi3q">{productName}</h3>
                <p className="mt-2 text-sm text-muted" data-id="element-170" data-mp="17tldyve5ekss">
                  All {totalVolumes} volumes + {totalBonuses} exclusive bonuses ready to use in your classroom.
                </p>
              </div>
              <div className="sm:text-right" data-id="element-171" data-mp="20ecxid89y6mr">
                <span className="text-sm text-muted" data-id="element-172" data-mp="1vgl7jor6wul7">
                  Regular price <span className="line-through" data-id="element-173" data-mp="1rfrjmvdqzfsb">{priceBefore}</span>
                </span>
                <p className="mt-1 font-display text-5xl font-extrabold text-gold" data-id="element-174" data-mp="1ri3xawch33zk">{price}</p>
                <p className="text-xs font-extrabold uppercase tracking-[.16em] text-earthDark" data-id="element-175" data-mp="jzuxtvnk5kmu">
                  Today · limited-time price
                </p>
              </div>
            </div>

            <ul className="mt-7 grid gap-2.5 sm:grid-cols-2" data-id="element-176" data-mp="hfx8bkapt7jl">
              {included.map(item => <li key={item} className="flex items-start gap-2.5 text-sm leading-snug text-ink" data-id="element-177" data-mp="mei85im21p7i">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-sage" aria-hidden="true" data-id="element-178" data-mp="7ly5sk6qblr4" />
                  {item}
                </li>)}
            </ul>

            <Button href={checkoutUrl} target="_blank" rel="noopener noreferrer" arrow className="mt-9 w-full" data-id="element-179" data-mp="3uvd0w5951t7v">
              Get my Teacher Ready now
            </Button>

            <div className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-muted" data-id="element-180" data-mp="3kzjfdwdfypdy">
              <span className="inline-flex items-center gap-1.5" data-id="element-181" data-mp="3py32w17oo98f">
                <LockIcon className="h-4 w-4 text-sageGlow" aria-hidden="true" data-id="element-182" data-mp="3bxjxz2yiljah" /> Secure payment
              </span>
              <span className="inline-flex items-center gap-1.5" data-id="element-183" data-mp="3fyc8dzj4hu8c">
                <ZapIcon className="h-4 w-4 text-sageGlow" aria-hidden="true" data-id="element-184" data-mp="2xatld5fcc49l" /> Instant access
              </span>
              <span className="inline-flex items-center gap-1.5" data-id="element-185" data-mp="2scs3uoxkcd08">
                <ShieldCheckIcon className="h-4 w-4 text-sage" aria-hidden="true" data-id="element-186" data-mp="2secvo6shthue" /> 7-day guarantee
              </span>
            </div>
            <p className="mt-4 text-center text-xs text-muted" data-id="element-187" data-mp="31cf4h8igxes8">
              You pay in USD. Your payment platform automatically shows the conversion to your local currency.
            </p>
          </div>
        </article>
      </div>
    </section>;
}